import { useSelector } from 'react-redux';

const useSalesTelephone = () => {
    const global_settings = useSelector(state => state.globalReducer.global_settings);
    const utm_source = useSelector((state) => state.userjourneyReducer?.userJourney?.['utm-source']);
    const utm_medium = useSelector((state) => state.userjourneyReducer?.userJourney?.['utm-medium']);

    const {ad_sales_telephone, sales_telephone} = global_settings;
    // const telephone = utm_source == 'google' ? ad_sales_telephone : sales_telephone;
    const telephone = utm_medium == 'cpc' && ad_sales_telephone != null && ad_sales_telephone != '' ? ad_sales_telephone : sales_telephone;

    return telephone;
}

export default useSalesTelephone;